export const auth = {
  login: "Login",
  register: "Create New Account",
  phone: "Phone Number",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  name: "Full Name",
  verifyOTP: "Verify Code",
  otpSent: "Verification code sent to your number",
  enterOTP: "Enter verification code",
  resendOTP: "Resend Code",
  forgotPassword: "Forgot Password?",
  createAccount: "Create Account",
  haveAccount: "Have an account? Login",
  noAccount: "Don't have an account? Create one",
  phoneRequired: "Phone number is required",
  passwordRequired: "Password is required",
  nameRequired: "Name is required",
  invalidPhone: "Invalid phone number",
  invalidEmail: "Invalid email",
  passwordMismatch: "Passwords don't match"
};